(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlumina-cinematic-interlude"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-v2-reveal')) {
 customElements.define('sl-v2-reveal', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.observer?.disconnect();this.controller=new AbortController();
   const motion=matchMedia('(prefers-reduced-motion: reduce)');
   if(motion.matches || !('IntersectionObserver' in window)) return;
   this.observer=new IntersectionObserver(entries=>{for(const entry of entries){if(!entry.isIntersecting)continue;this.observer.unobserve(entry.target);if(motion.matches)continue;this.classList.add('sl-v2-seen');entry.target.classList.add('sl-v2-enter');entry.target.addEventListener('animationend',()=>entry.target.classList.remove('sl-v2-enter'),{once:true,signal:this.controller.signal});}}, {threshold:.12});
   for(const el of this.querySelectorAll('[data-sl-reveal]'))this.observer.observe(el);
   motion.addEventListener('change',()=>{if(!motion.matches)return;this.observer?.disconnect();for(const el of this.querySelectorAll('.sl-v2-enter'))el.classList.remove('sl-v2-enter');},{signal:this.controller.signal});
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlumina-editorial-collections"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sl-collection-story'))customElements.define('sl-collection-story',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.observer?.disconnect();this.controller=new AbortController();
  this.section=this.querySelector('.sl-collection-story');this.track=this.querySelector('.sl-collection-story__track');this.stage=this.querySelector('.sl-collection-story__stage');this.chapters=[...this.querySelectorAll('[data-chapter]')];
  if(!this.section||!this.track||!this.stage||!this.chapters.length)return;
  this.media=matchMedia('(min-width:1000px) and (prefers-reduced-motion:no-preference)');
  this.apply=()=>{const active=this.hasAttribute('data-sticky-experiment')&&this.media.matches;this.section.classList.toggle('sl-collection-story--enhanced',active);this.enhanced=active;this.current=-1;if(!active){for(const chapter of this.chapters){chapter.classList.remove('is-current');chapter.removeAttribute('aria-hidden');chapter.inert=false;}return;}this.update();};
  this.update=()=>{if(!this.enhanced)return;const box=this.track.getBoundingClientRect();const travel=Math.max(1,box.height-this.stage.getBoundingClientRect().height);const progress=Math.max(0,Math.min(.999,(-box.top+innerHeight*.10)/travel));let index=Math.min(this.chapters.length-1,Math.floor(progress*this.chapters.length));const focused=this.chapters.findIndex(c=>c.contains(document.activeElement));if(focused>=0)index=focused;if(index===this.current)return;this.current=index;this.section.dataset.current=String(index);this.chapters.forEach((chapter,i)=>{chapter.classList.toggle('is-current',i===index);chapter.setAttribute('aria-hidden',String(i!==index));chapter.inert=i!==index;});};
  this.schedule=()=>{if(this.frame||!this.enhanced||!this.visible)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
  this.media.addEventListener('change',this.apply,{signal:this.controller.signal});window.addEventListener('scroll',this.schedule,{passive:true,signal:this.controller.signal});window.addEventListener('resize',this.schedule,{passive:true,signal:this.controller.signal});
  if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.schedule();},{rootMargin:'200px'});this.observer.observe(this.track);}else this.visible=true;
  this.apply();
 }
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlumina-emotion-hero"] && !Shopify.designMode) return;
  try {
    
/* Present the existing Welcome Gift after 35% page scroll on the mobile homepage. */
if (document.querySelector('.sl-home-hero') && document.querySelector('#header-component[data-page-type="index"]') && window.matchMedia('(max-width: 749px)').matches) {
  const revealWelcomeGift = () => {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableHeight > 0 && window.scrollY / scrollableHeight >= 0.35) {
      document.body.classList.add('sl-hero-welcome-ready');
      window.removeEventListener('scroll', revealWelcomeGift);
    }
  };
  window.addEventListener('scroll', revealWelcomeGift, { passive: true });
  revealWelcomeGift();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlumina-emotion-philosophy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-v2-reveal')) {
 customElements.define('sl-v2-reveal', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.observer?.disconnect();this.controller=new AbortController();
   const motion=matchMedia('(prefers-reduced-motion: reduce)');
   if(motion.matches || !('IntersectionObserver' in window)) return;
   this.observer=new IntersectionObserver(entries=>{for(const entry of entries){if(!entry.isIntersecting)continue;this.observer.unobserve(entry.target);if(motion.matches)continue;this.classList.add('sl-v2-seen');entry.target.classList.add('sl-v2-enter');entry.target.addEventListener('animationend',()=>entry.target.classList.remove('sl-v2-enter'),{once:true,signal:this.controller.signal});}}, {threshold:.12});
   for(const el of this.querySelectorAll('[data-sl-reveal]'))this.observer.observe(el);
   motion.addEventListener('change',()=>{if(!motion.matches)return;this.observer?.disconnect();for(const el of this.querySelectorAll('.sl-v2-enter'))el.classList.remove('sl-v2-enter');},{signal:this.controller.signal});
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlumina-intention-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-home-collection-reveal')) {
  customElements.define('sl-home-collection-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;
      this.abortController = new AbortController();
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      if (preference.matches || !matchMedia('(min-width: 750px)').matches || !('IntersectionObserver' in window)) return;
      const cards = [...this.querySelectorAll('.sl-intention-5__card')];
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.observer.unobserve(entry.target);
          if (preference.matches) continue;
          const card = entry.target;
          card.style.setProperty('--sl-home-entry-delay', `${Math.min(cards.indexOf(card), 3) * 80}ms`);
          card.classList.add('sl-home-card-entering');
          const finish = () => card.classList.remove('sl-home-card-entering');
          card.addEventListener('animationend', finish, { once: true, signal: this.abortController.signal });
          card.addEventListener('animationcancel', finish, { once: true, signal: this.abortController.signal });
        }
      }, { threshold: 0.12 });
      for (const card of cards) this.observer.observe(card);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlumina-intention-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sl-v3-story'))customElements.define('sl-v3-story',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.observer?.disconnect();this.controller=new AbortController();
  this.section=this.querySelector('.sl-v3-story');this.track=this.querySelector('.sl-v3-story__track');this.chapters=[...this.querySelectorAll('[data-chapter]')];
  if(!this.section||!this.track||!this.chapters.length)return;
  this.media=matchMedia('(min-width:1000px) and (prefers-reduced-motion:no-preference)');
  this.apply=()=>{const active=this.hasAttribute('data-sticky-experiment')&&this.media.matches;this.section.classList.toggle('sl-v3-story--enhanced',active);this.enhanced=active;this.current=-1;if(!active){for(const chapter of this.chapters){chapter.classList.remove('is-current');chapter.removeAttribute('aria-hidden');chapter.inert=false;}return;}this.update();};
  this.update=()=>{if(!this.enhanced)return;const box=this.track.getBoundingClientRect();const travel=Math.max(1,box.height-innerHeight*.86);const progress=Math.max(0,Math.min(.999,(-box.top+innerHeight*.07)/travel));let index=Math.min(this.chapters.length-1,Math.floor(progress*this.chapters.length));const focused=this.chapters.findIndex(c=>c.contains(document.activeElement));if(focused>=0)index=focused;if(index===this.current)return;this.current=index;this.section.dataset.current=String(index);this.chapters.forEach((chapter,i)=>{chapter.classList.toggle('is-current',i===index);chapter.setAttribute('aria-hidden',String(i!==index));chapter.inert=i!==index;});};
  this.schedule=()=>{if(this.frame||!this.enhanced||!this.visible)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
  this.media.addEventListener('change',this.apply,{signal:this.controller.signal});window.addEventListener('scroll',this.schedule,{passive:true,signal:this.controller.signal});window.addEventListener('resize',this.schedule,{passive:true,signal:this.controller.signal});
  if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.schedule();},{rootMargin:'200px'});this.observer.observe(this.track);}else this.visible=true;
  this.apply();
 }
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();
})();
